/**
 * PickerTrigger — pill button that opens the album picker overlay.
 * Lives in the topbar. Receives the current album for label rendering.
 */

import { forwardRef, type ButtonHTMLAttributes, type MouseEvent } from 'react';
import { useTrack } from '@/analytics';
import type { AvailableAlbumModule } from '@/types/album';

interface PickerTriggerProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  album: AvailableAlbumModule;
}

export const PickerTrigger = forwardRef<HTMLButtonElement, PickerTriggerProps>(
  function PickerTrigger({ album, onClick, ...rest }, ref) {
    const track = useTrack();
    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
      track('Picker Open', {});
      onClick?.(event);
    };
    return (
      <button
        ref={ref}
        type="button"
        className="ap-trigger"
        aria-haspopup="dialog"
        aria-label={`Cambiar de álbum. Actualmente: ${album.library.album} de ${album.library.artist}`}
        {...rest}
        onClick={handleClick}
      >
        <span className="ap-trigger-eyebrow">Disco</span>
        <span className="ap-trigger-current">
          <span className="ap-trigger-dot" aria-hidden="true" />
          <span className="ap-trigger-album">{album.library.album}</span>
          <em>· {album.library.artist}</em>
        </span>
        <span className="ap-trigger-arrow" aria-hidden="true">
          Cambiar →
        </span>
      </button>
    );
  }
);
